<template>
    <div class="pb-[120px] lg:px-[var(--padding-lg)] lg:pb-40">
        <section class="lg:pt-[120px]">
            <MoleculesBanner
                :title="pageContent?.title"
                :marquee="
                    page === 'news'
                        ? t('news.banner.news')
                        : t('news.banner.awards')
                "
            />
        </section>
        <section v-if="page === 'news' && state.currentPage === 1">
            <OrganismsNewsHighlight :title="pageContent?.latest?.title" />
        </section>

        <section>
            <OrganismsNewsList
                :page="page"
                :title="page === 'news' ? pageContent?.more?.title : null"
            />
        </section>
        <section>
            <MoleculesPagination
                :currentPage="state.currentPage"
                :totalPages="state.totalPages"
                :itemsPerPage="state.maxPostsPerPage"
                @update:currentPage="handlePageChange"
            />
        </section>
    </div>
</template>

<script setup>
import { createPostsContext } from "@/composables/usePostsContext";
const { page = "news" } = defineProps({
    page: {
        type: String,
        default: "news",
    },
});
const { t } = useI18n();

// Create posts context at the template level
const postsContext = createPostsContext();
const { state, handlePageChange, fetchPosts } = postsContext;

// Fetch page data
const { fetchPage } = useFetchAPI();
const { data: pageData } = await fetchPage(page);
const pageContent = pageData.value?.meta_box || {};

const highlightedPostsIDs = pageContent?.latest?.data?.map((p) => p.id) || [];

fetchPosts(page, highlightedPostsIDs);

const { setHeaderMode } = useMode();
const { setMeta } = useMeta();
onMounted(() => {
    setHeaderMode("light");
});

await setMeta(pageData.value);
</script>
